import { render, staticRenderFns } from "./RulesEngineSetup.vue?vue&type=template&id=68e32ed0&scoped=true"
import script from "./RulesEngineSetup.vue?vue&type=script&lang=ts"
export * from "./RulesEngineSetup.vue?vue&type=script&lang=ts"
import style0 from "./RulesEngineSetup.vue?vue&type=style&index=0&id=68e32ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e32ed0",
  null
  
)

export default component.exports